/** Match backend `CommunityRecipe.MainProtein` and `recipe_matching.RECIPE_MAIN_VEGETABLE_SLUGS`. */

export const RECIPE_MAIN_PROTEINS = [
  { value: 'none', label: 'None / vegetarian' },
  { value: 'venison', label: 'Venison / deer' },
  { value: 'turkey', label: 'Turkey' },
  { value: 'quail', label: 'Quail' },
  { value: 'rabbit', label: 'Rabbit' },
  { value: 'squirrel', label: 'Squirrel' },
  { value: 'dove', label: 'Dove / pigeon' },
  { value: 'duck', label: 'Duck / waterfowl' },
  { value: 'wild_boar', label: 'Wild boar / hog' },
  { value: 'fish', label: 'Fish' },
  { value: 'other_game', label: 'Other game' },
  { value: 'beef', label: 'Beef' },
  { value: 'pork', label: 'Pork' },
  { value: 'chicken', label: 'Chicken' },
];

export const RECIPE_MAIN_VEGETABLES = [
  { value: 'onion', label: 'Onion' },
  { value: 'garlic', label: 'Garlic' },
  { value: 'potato', label: 'Potato' },
  { value: 'sweet_potato', label: 'Sweet potato' },
  { value: 'carrot', label: 'Carrot' },
  { value: 'pepper', label: 'Hot pepper / chili' },
  { value: 'bell_pepper', label: 'Bell pepper' },
  { value: 'asparagus', label: 'Asparagus' },
  { value: 'mushroom', label: 'Mushroom' },
  { value: 'tomato', label: 'Tomato' },
  { value: 'greens', label: 'Greens / lettuce' },
  { value: 'corn', label: 'Corn' },
  { value: 'beans', label: 'Beans' },
  { value: 'celery', label: 'Celery' },
  { value: 'squash', label: 'Squash' },
  { value: 'cabbage', label: 'Cabbage' },
  { value: 'lime', label: 'Lime' },
  { value: 'lemon', label: 'Lemon' },
  { value: 'broccoli', label: 'Broccoli' },
  { value: 'cauliflower', label: 'Cauliflower' },
  { value: 'zucchini', label: 'Zucchini' },
  { value: 'jalapeno', label: 'Jalapeño' },
  { value: 'spinach', label: 'Spinach' },
  { value: 'kale', label: 'Kale' },
];

/** Stored on each ingredient line as `unit` (backend string, max 64). */
export const RECIPE_INGREDIENT_UNITS = [
  { value: 'lb', label: 'Pound(s)' },
  { value: 'oz', label: 'Ounce(s)' },
  { value: 'g', label: 'Gram(s)' },
  { value: 'kg', label: 'Kilogram(s)' },
  { value: 'cup', label: 'Cup(s)' },
  { value: 'tbsp', label: 'Tablespoon(s)' },
  { value: 'tsp', label: 'Teaspoon(s)' },
  { value: 'ml', label: 'Milliliter(s)' },
  { value: 'l', label: 'Liter(s)' },
  { value: 'pint', label: 'Pint(s)' },
  { value: 'quart', label: 'Quart(s)' },
  { value: 'gallon', label: 'Gallon(s)' },
  { value: 'pinch', label: 'Pinch' },
  { value: 'handful', label: 'Handful' },
  { value: 'dash', label: 'Dash' },
  { value: 'to_taste', label: 'To taste' },
  { value: 'whole', label: 'Whole' },
  { value: 'piece', label: 'Piece(s)' },
  { value: 'clove', label: 'Clove(s)' },
  { value: 'sprig', label: 'Sprig(s)' },
  { value: 'can', label: 'Can(s)' },
  { value: 'bunch', label: 'Bunch(es)' },
  { value: 'stick', label: 'Stick(s) (butter)' },
  { value: 'package', label: 'Package' },
  { value: 'slice', label: 'Slice(s)' },
];

const INGREDIENT_UNIT_LABEL_BY_VALUE = Object.fromEntries(
  RECIPE_INGREDIENT_UNITS.map((u) => [u.value, u.label]),
);

/** Friendly label for API/storage value, or original string if unknown (legacy recipes). */
export function ingredientUnitLabel(value) {
  if (value == null || String(value).trim() === '') return '';
  return INGREDIENT_UNIT_LABEL_BY_VALUE[value] || String(value);
}

export const RECIPE_REPORT_CATEGORIES = [
  { value: 'inappropriate_photo', label: 'Inappropriate photo' },
  { value: 'inappropriate_text', label: 'Inappropriate text' },
  { value: 'spam', label: 'Spam' },
  { value: 'other', label: 'Other' },
];

export const MAX_RECIPE_PHOTOS = 1;
